import Feature from './YunyuFeature.js';
import BoundingBox from '../ref/BoundingBox.js';

export default {
  title: 'Yunyu GeoJSON FeatureCollection',
  type: 'object',
  required: ['type', 'features'],
  properties: {
    type: {
      type: 'string',
      enum: ['FeatureCollection']
    },
    features: {
      type: 'array',
      items: Feature
    },
    bbox: BoundingBox
  }
};
